import { ThemeOptions } from '@mui/material/styles/createTheme';
import { ChipProps } from '@mui/material/Chip';
import { alpha } from '@mui/material';

export const MuiChipStyle = {
  styleOverrides: {
    root: ({ theme, ownerState }: { theme: ThemeOptions, ownerState: ChipProps }) => {
      const ownerStateColor = ownerState?.color || 'inherit';

      if (ownerStateColor === 'error') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const redDark = theme?.palette?.error?.dark ?? '#AB1F26';
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const redLight = theme?.palette?.error?.light ?? '#E86363';
        return {
          color: redDark,
          backgroundColor: alpha(redLight, 0.3),
          '.MuiChip-deleteIcon': {
            color: redDark + ' !important',
            '&:hover': {
              color: alpha(redDark, 0.5) + ' !important',
            },
          },
          '&.Mui-focusVisible': {
            backgroundColor: alpha(redDark, 0.3),
          }
        };
      }
      if (ownerStateColor === 'default') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const textPrimary = theme?.palette?.text?.primary ?? '#252A2E';
        return {
          '.MuiChip-deleteIcon': {
            color: textPrimary,
            '&:hover': {
              color: alpha(textPrimary, 0.5)
            }
          }
        }
      }
    }
  }
};
